/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export default (function () {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/core/es/lib/noop.js
// module id = 805
// module chunks = 0